import uuid from 'uuid/v4';
import when from 'when';
import wamp from '../../appserver/js-jobserver/lib/wamp';
import { Box } from '../../common/box';
import { Board } from '../../common/board';

async function submitSimulation(projectId: number, boardId: number) {

  const cmd = [
    projectId,
    boardId,
  ];

  let kwargs = null;
  const jobId = uuid();

  kwargs = Object.assign({}, kwargs, {
    id: jobId,
    streamId: `job.eventstream.${jobId}`,
  });

  // Set up stream before calling, to make sure we do not miss events
  // TODO: Do not allow client to decide id and streamId !
  try {

    wamp.subscribe(kwargs.streamId, ([event]) => {
      // console.log(`event: ${event.type}`);

      if (jobHandle.onEvent) {
        jobHandle.onEvent(event);
      }

      if (event.type === 'log') {
        console.log(`[job:${id}][${event.stream}][${event.time}] ${event.message.trim()}`);
      } else if (event.type === 'exit') {
        const errorMsg = event.status === 0 ? '' : '(error: ${event.error})';

        console.log(`[job:${id}][${event.time}] Exit with status ${event.status} ${errorMsg}`);
        exitDeferred.resolve(event);
      }

    });

  } catch (e) {
    console.log(`Subscription error!!`);
  }

  const [id, streamId] = await wamp.call<string[]>('bct-simulation.execute', cmd, kwargs);

  if (id !== kwargs.id || streamId !== kwargs.streamId) {
    throw Error('Job id does not match');
  }

  const exitDeferred = when.defer();

  const jobHandle = {
    onEvent: null,
    exitPromise: exitDeferred.promise,
    id,
    uri: streamId,
  };

  return jobHandle;
}

async function getResults(jobId) {
  const cmd = [
    jobId,
  ];

  const resultURLs: any = await wamp.call<string[]>('bct-simulation.get-results', cmd);

  return resultURLs;
}

export default wamp;
export { submitSimulation, getResults };



// WEBPACK FOOTER //
// ./src/wamp.ts